export const NOTIFICATION_CHANNELS = {
  WHATSAPP: {
    name     : 'whatsapp',
    value    : 'whatsapp',
    disabled : false
  },
  SMS: {
    name     : 'sms',
    disabled : true
  },
  PUSH_NOTIFICATION: {
    name     : 'push notification',
    value    : 'push_notification',
    disabled : true
  }
}

export const NOTIFICATION_RECEIVERS = {
  USER     : 'user',
  CUSTOMER : 'customer',
  SELLER   : 'seller'
}


export const NOTIFICATION_PROVIDERS = {
  TWILIO: {
    name     : 'twilio',
    value    : 'twilio',
    disabled : true
  },
  FRESHCHAT: {
    name     : 'freshchat',
    value    : 'freshchat',
    disabled : false
  },
  META: {
    name     : 'meta',
    value    : 'meta',
    disabled : false
  }
}

export const BUTTON_OPTIONS = {
  URL: {
    name     : 'Url Website',
    value    : 'url',
    disabled : false
  },
  PHONE_NUMBER: {
    name     : 'Call Phone Number',
    value    : 'phone_number',
    disabled : false
  }
}

export const INPUT_FORMATS = {
  DEFAULT    : 'default',
  CAPITALIZE : 'capitalize',
  UPPERCASE  : 'uppercase',
  LOWERCASE  : 'lowercase'
}

export const USER_ATTRIBUTES = {
  ID       : 'id',
  NAME     : 'name',
  EMAIL    : 'email',
  MOBILE   : 'mobile',
  BIRTHDAY : 'birthday'
}

export const CUSTOMER_ATTRIBUTES = {
  ID       : 'id',
  NAME     : 'name',
  EMAIL    : 'email',
  PHONE_NO : 'mobile',
  BIRTHDAY : 'birthday'
}

export const SELLER_ATTRIBUTES = {
  ID          : 'id',
  NAME        : 'name',
  EMAIL       : 'email',
  PHONE       : 'mobile',
  BIRTHDAY_AT : 'birthday',
  USERNAME    : 'username',
  URL_KEY     : 'url_key'
}
